module.exports = __webpack_public_path__ + "static/media/SF-Pro-Text-Bold.5b6c7cdf.otf";